import React from "react"

import { Link } from "gatsby"
import Logo from "../images/my-radar-logo.png"
import IconFacebook from "../images/icon-facebook.png"
import IconInstagram from "../images/icon-instagram.png"
import IconX from "../images/icon-x.png"
import IconYouTube from "../images/icon-youtube.png"
import Counter from "../images/logo-counter.png"

class Footer extends React.Component {
  render() {
    return (
      <footer className="row">
        <div className="cell well">
          <div className="footer">
            <a
              href="https://go.onelink.me/ebEx/a3553bd0"
              className="download-button"
            >
              Download MyRadar!
            </a>
            <div className="col-1">
              <img src={Logo} alt="MyRadar" className="logo" />
              <div className="footer-social">
                <a
                  href="https://facebook.com/myradar"
                  className="logo logo--social"
                >
                  <img src={IconFacebook} alt="facebook logo" />
                </a>

                <a
                  href="https://youtube.com/myradar"
                  className="logo logo--social"
                >
                  <img src={IconYouTube} alt="youtube logo" />
                </a>

                <a
                  href="https://x.com/myradarwx"
                  className="logo logo--social"
                >
                  <img src={IconX} alt="x logo" />
                </a>

                <a
                  href="https://instagram.com/myradar"
                  className="logo logo--social"
                >
                  <img src={IconInstagram} alt="instagram logo" />
                </a>
              </div>{" "}
              {/*footer-social*/}
              <div className="copyright">&copy; 2024</div>
              <a href="https://business.myradar.com/contact">Contact Us</a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a href="https://business.myradar.com/contact">Media Inquiries</a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a href="https://jobs.acmeaom.com">Jobs</a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a href="https://business.myradar.com/developer_portal">Developer API</a>&nbsp;&nbsp;
              <br/>
              <a href="https://myradar.space/project-horis/">MyRadar.space</a>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <a href="/road-weather">Road Weather</a>&nbsp;&nbsp;
            </div>
            {/*col-1*/}
            <div className="col-2">
              {/*<Link to="/privacy">Consumer Application</Link>
                <Link to="/privacy">Commercial Capabilities</Link>*/}
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/california-notice">
                Notice to California Residents
              </Link>
              <Link to="/opt-out">Do Not Sell My Information</Link>
            </div>{" "}
            {/*col-1*/}
            <div className="col-3">
              Creative by
              <a className="counter-logo" href="https://thisiscounter.com/">
                <img src={Counter} alt="counter logo" />
              </a>
            </div>{" "}
            {/*col-3*/}
          </div>{" "}
          <p>LEGAL DISCLAIMER: NO MONEY OR OTHER CONSIDERATION IS BEING SOLICITED, AND IF SENT IN RESPONSE, WILL NOT BE ACCEPTED. NO OFFER TO BUY THE SECURITIES CAN BE ACCEPTED AND NO PART OF THE PURCHASE PRICE CAN BE RECEIVED UNTIL THE OFFERING STATEMENT IS FILED AND ONLY THROUGH AN INTERMEDIARY’S PLATFORM. AN INDICATION OF INTEREST INVOLVES NO OBLIGATION OR COMMITMENT OF ANY KIND. "RESERVING" SECURITIES IS SIMPLY AN INDICATION OF INTEREST.</p>
          {/*footer*/}
        </div>{" "}
        {/*cell-well*/}
      </footer>
    )
  }
}

export default Footer
